export enum ETrackPeriod {
  HOURS_6 = 'H6',
  HOURS_24 = 'H24',
  DAYS_3 = 'D3',
  DAYS_7 = 'D7',
  DAYS_14 = 'D14',
  DAYS30 = 'D30',
  DAYS90 = 'D90'
}
